import {
	DEFAULT_SETTINGS_REQUEST,
	DEFAULT_SETTINGS_FAIL,
	DEFAULT_SETTINGS_SUCCESS,
} from "./types";
import {defaults} from "../../Playground";

export const getDefaultSettings = () => async (dispatch) => {
	try {
		dispatch({type: DEFAULT_SETTINGS_REQUEST});
		// TODO: In future get this data from API with projectName a primary key and set the data
		dispatch({
			type: DEFAULT_SETTINGS_SUCCESS,
			payload: {data: defaults},
		});
	} catch (error) {
		dispatch({
			type: DEFAULT_SETTINGS_FAIL,
			payload: {
				error:
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
			},
		});
	}
};
